import React, { useState, createContext } from "react";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "lib/assets/svg/close";

// Create a context to manage the toaster state
const AlertContext = createContext();

// Global reference to the `showToaster` function
let globalShowToaster;

// Provider component that will wrap your app
export const AlertProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState("");
  const [severity, setSeverity] = useState("info");
  const [duration, setDuration] = useState(2000);

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  const showToaster = (msg, sev, timer) => {
    setMessage(msg);
    setSeverity(sev);
    setDuration(timer || 2000);
    setOpen(true);
  };

  // Assign the `showToaster` function to the global reference
  globalShowToaster = showToaster;

  const action = (
    <IconButton
      size="small"
      aria-label="close"
      color="inherit"
      onClick={handleClose}
    >
      <CloseIcon fontSize="small" />
    </IconButton>
  );

  return (
    <AlertContext.Provider value={{ showToaster }}>
      {children}
      <Snackbar
        open={open}
        autoHideDuration={duration}
        onClose={handleClose}
        action={action}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <MuiAlert
          elevation={6}
          variant="filled"
          onClose={handleClose}
          severity={severity}
          sx={{ width: "100%" }}
        >
          {message}
        </MuiAlert>
      </Snackbar>
    </AlertContext.Provider>
  );
};

// Export toaster functions for global usage
export const successToaster = (msg, timer) => {
  if (globalShowToaster) {
    globalShowToaster(msg, "success", timer);
  } else {
    console.error(
      "Toaster is not initialized. Wrap your app with AlertProvider."
    );
  }
};

export const errorToaster = (msg, timer) => {
  if (globalShowToaster) {
    globalShowToaster(msg || "Something went wrong", "error", timer);
  } else {
    console.error(
      "Toaster is not initialized. Wrap your app with AlertProvider."
    );
  }
};

export const warningToaster = (msg, timer) => {
  if (globalShowToaster) {
    globalShowToaster(msg, "warning", timer);
  } else {
    console.error(
      "Toaster is not initialized. Wrap your app with AlertProvider."
    );
  }
};

export const infoToaster = (msg, timer) => {
  if (globalShowToaster) {
    globalShowToaster(msg || "Information", "info", timer);
  } else {
    console.error(
      "Toaster is not initialized. Wrap your app with AlertProvider."
    );
  }
};

export const questionToaster = (msg, timer) => {
  if (globalShowToaster) {
    globalShowToaster(msg || "Question", "info", timer);
  } else {
    console.error(
      "Toaster is not initialized. Wrap your app with AlertProvider."
    );
  }
};
